// Generated by purs version 0.14.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_WeakDynamic from "../Specular.FRP.WeakDynamic/index.js";
var Ref = (function () {
    function Ref(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Ref.create = function (value0) {
        return function (value1) {
            return new Ref(value0, value1);
        };
    };
    return Ref;
})();
var value = function (v) {
    return v.value0;
};
var refValue = value;
var read = function (dictMonadEffect) {
    return function (v) {
        return Specular_FRP_Base.readDynamic(dictMonadEffect)(v.value0);
    };
};
var readRef = function (dictMonadEffect) {
    return read(dictMonadEffect);
};
var pureFocusRef = function (lens) {
    return function (v) {
        return new Ref(Data_Functor.map(Specular_FRP_Base.functorDynamic)(lens.get)(v.value0), function ($63) {
            return v.value1((function (modify_a) {
                return function (s) {
                    return lens.set(s)(modify_a(lens.get(s)));
                };
            })($63));
        });
    };
};
var previewRef = function (prism) {
    return function (v) {
        return new Ref(Data_Functor.map(Specular_FRP_Base.functorDynamic)(prism.preview)(v.value0), function ($64) {
            return v.value1((function (modify_a) {
                return function (s) {
                    var v1 = modify_a(prism.preview(s));
                    if (v1 instanceof Data_Maybe.Just) {
                        return prism.review(v1.value0);
                    };
                    return s;
                };
            })($64));
        });
    };
};
var newWithEvent = function (dictMonadFRP) {
    return function (initial) {
        return function (extraUpdate) {
            return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.newDynamic(dictMonadFRP.MonadEffect0())(initial))(function (v) {
                return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.subscribeEvent_(dictMonadFRP.MonadEffect0())(dictMonadFRP.MonadCleanup1())(v.modify)(extraUpdate))(function () {
                    return Control_Applicative.pure(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(new Ref(v.dynamic, v.modify));
                });
            });
        };
    };
};
var newRefWithEvent = function (dictMonadFRP) {
    return newWithEvent(dictMonadFRP);
};
var $$new = function (dictMonadEffect) {
    return function (initial) {
        return Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(Specular_FRP_Base.newDynamic(dictMonadEffect)(initial))(function (v) {
            return Control_Applicative.pure((dictMonadEffect.Monad0()).Applicative0())(new Ref(v.dynamic, v.modify));
        });
    };
};
var newRef = function (dictMonadEffect) {
    return $$new(dictMonadEffect);
};
var modify = function (dictMonadEffect) {
    return function (v) {
        var $65 = Effect_Class.liftEffect(dictMonadEffect);
        return function ($66) {
            return $65(v.value1($66));
        };
    };
};
var refUpdate = function (dictMonadEffect) {
    return modify(dictMonadEffect);
};
var write = function (dictMonadEffect) {
    return function (r) {
        var $67 = modify(dictMonadEffect)(r);
        return function ($68) {
            return $67((function (new_) {
                return function (_old) {
                    return new_;
                };
            })($68));
        };
    };
};
var refUpdateConst = function (dictMonadEffect) {
    return write(dictMonadEffect);
};
var set = function (dictMonadEffect) {
    return write(dictMonadEffect);
};
var wrapViewWidget = function (dictMonadWidget) {
    return function (widget) {
        return function (v) {
            return Control_Bind.bind((((dictMonadWidget.MonadReplace2()).MonadCleanup1()).Monad0()).Bind1())(widget(Specular_FRP_WeakDynamic.weaken(v.value0)))(function (updateE) {
                return Specular_FRP_Base.subscribeEvent_((dictMonadWidget.MonadFRP1()).MonadEffect0())((dictMonadWidget.MonadReplace2()).MonadCleanup1())(set(Effect_Class.monadEffectEffect)(v))(updateE);
            });
        };
    };
};
var updateRef = function (dictMonadEffect) {
    return write(dictMonadEffect);
};
var invariantRef = {
    imap: function (f) {
        return function (g) {
            return function (v) {
                return new Ref(Data_Functor.map(Specular_FRP_Base.functorDynamic)(f)(v.value0), function ($69) {
                    return v.value1((function (h) {
                        return function ($70) {
                            return g(h(f($70)));
                        };
                    })($69));
                });
            };
        };
    }
};
var focusRef = function (lensD) {
    return function (v) {
        return new Ref(Control_Apply.lift2(Specular_FRP_Base.applyDynamic)(function (v1) {
            return v1.get;
        })(lensD)(v.value0), function (x) {
            return function __do() {
                var f = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(lensD)(function (lens) {
                    return function (modify_a) {
                        return function (s) {
                            return lens.set(s)(modify_a(lens.get(s)));
                        };
                    };
                }))();
                return v.value1(f(x))();
            };
        });
    };
};
var $$const = function (x) {
    return new Ref(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(x), Data_Function["const"](Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit)));
};
var constRef = $$const;
export {
    Ref,
    $$new as new,
    newWithEvent,
    $$const as const,
    value,
    modify,
    read,
    write,
    focusRef,
    pureFocusRef,
    previewRef,
    wrapViewWidget,
    newRef,
    newRefWithEvent,
    constRef,
    readRef,
    updateRef,
    set,
    refUpdateConst,
    refValue,
    refUpdate,
    invariantRef
};
//# sourceMappingURL=index.js.map
